import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';

import { OcrScanAnimation } from './OcrScanAnimation';

interface OcrUploadLoadingModalProps {
  isOpen: boolean;
}

export const OcrUploadLoadingModal = ({
  isOpen,
}: OcrUploadLoadingModalProps) => (
  <Modal
    isCentered
    closeOnEsc={false}
    closeOnOverlayClick={false}
    isOpen={isOpen}
    onClose={() => undefined}
  >
    <ModalOverlay bg="rgba(19, 20, 21, 0.64)" />
    <ModalContent borderRadius="8px" maxW="368px" mx={4} p={0}>
      <ModalBody px="32px" pb="28px" pt="24px">
        <Stack align="center" spacing={4}>
          <OcrScanAnimation />

          <Stack alignSelf="stretch" spacing={2}>
            <Text
              color="#373F41"
              fontSize="18px"
              fontWeight={700}
              lineHeight="22px"
            >
              Mengunggah & menganalisa bukti transfer ...
            </Text>
            <Text
              color="#373F41"
              fontSize="14px"
              fontWeight={400}
              lineHeight="20px"
            >
              Jangan menutup atau meninggalkan halaman demi kelancaran proses
              unggah.
            </Text>
          </Stack>
        </Stack>
      </ModalBody>
    </ModalContent>
  </Modal>
);
